import { EventBuilder } from './EventBuilder';
import { SocialActionTypes } from './SocialParamBuilder';
import { v4 as uuid } from 'uuid';
import Core from '../Core/Core';
import { Views } from '../State/reducers/view';
import { getLevelIndex } from '../State/reducers/level';
import { DDNAEvents } from './Tracker';

export enum TransactionTypes {
    REWARD = 'reward',
    COIN_PURCHASE = 'coin purchase',
    PURCHASE = 'purchase',
    AD = 'ad',
    INVENTORY = 'inventory',
}

export enum TGameAreas {
    MAP = 'map',
    LEVEL = 'level',
}

export enum TransactionActionTypes {
    WHEEL_SPIN = 'wheel spin',
    BOOSTER_USE = 'booster use',
    INVENTORY_PURCHASE = 'inventory purchase',
    TREASURE_HUNT = 'treasure hunt', // we won't use this
    MAP_CHEST = 'map chest',
    WIN_SEQUENCE = 'win sequence',
    GATE = 'gate', // or this
    AD = 'ad', // is there a way we can have an 'ad' transaction type that doesn't originate from this action
    SOCIAL = 'social',
    BOT = 'bot',
    REWARD = 'reward',
    DAILY_MISSION = 'daily mission',
}

export interface IResourceParams extends IResourceActionData {
    tLevelContext: number; //.
    tMovesLeft: number; //.
    transactionID: string; // just create one?
    realCurrencyAmount: number; //. will always be 0 now
    realCurrencyType: string; //. how is this a number?...or should be string enum?...and what if none involved?
    tGameArea: TGameAreas;
}

// passed in with event?
export interface IResourceActionData {
    tCoinsRecieved: number;
    tCoinsUsed: number;
    tMagnifyingGlassReceived: number;
    tMagnifyingGlassUsed: number;
    tFlashLightReceived: number;
    tFlashlightUsed: number;
    tFireCrackerReceived: number;
    tFireCrackerUsed: number;
    tMagnetReceived: number;
    tMagnetUsed: number;
    tShuffleReceived: number;
    tShuffleUsed: number;
    tTimeReceived: number;
    tTimeUsed: number;
    tEventType: TransactionTypes;
    tActionType: TransactionActionTypes;
    adID: string;
    socialActionType: SocialActionTypes;
    socialSend: number;
    socialRecieve: number;
    tGameArea: TGameAreas;
}

const defaultResourceData: IResourceParams = {
    tLevelContext: 0,
    tMovesLeft: 0,
    transactionID: '',
    realCurrencyAmount: 0,
    realCurrencyType: null,
    tCoinsRecieved: 0,
    tCoinsUsed: 0,
    tMagnifyingGlassReceived: 0,
    tMagnifyingGlassUsed: 0,
    tFlashLightReceived: 0,
    tFlashlightUsed: 0,
    tFireCrackerReceived: 0,
    tFireCrackerUsed: 0,
    tMagnetReceived: 0,
    tMagnetUsed: 0,
    tShuffleReceived: 0,
    tShuffleUsed: 0,
    tTimeReceived: 0,
    tTimeUsed: 0,
    tEventType: TransactionTypes.INVENTORY,
    tActionType: TransactionActionTypes.BOOSTER_USE,
    adID: 'none',
    socialActionType: SocialActionTypes.NONE,
    socialSend: 0,
    socialRecieve: 0,
    tGameArea: TGameAreas.MAP,
};

export class ResourceParamBuilder extends EventBuilder {
    private curResourceData: IResourceActionData;

    constructor() {
        super();

        this.curResourceData = { ...defaultResourceData };
    }

    public getCurrentResourceData() {
        return this.curResourceData;
    }

    // unused for resource
    public setParamsFromGame(resourceActionData: IResourceActionData): void {
        const oldResourceData = this.curResourceData;
        this.curResourceData = Object.assign(oldResourceData, resourceActionData);
    }

    public getParams<T>(
        event: DDNAEvents,
        resourceActionData: IResourceActionData
    ): IResourceParams {
        const state = Core.store.getState();
        return {
            ...resourceActionData,
            tLevelContext:
                state.StateView === Views.GAME
                    ? getLevelIndex(state.StateLevel.levelId)
                    : state.StateLevel.prelevel !== ''
                        ? getLevelIndex(state.StateLevel.prelevel)
                        : 0,
            tMovesLeft:
                state.StateView === Views.GAME ? state.StateBoard.availableMatches.length : 0,
            transactionID: uuid(), //.
            realCurrencyAmount: 0, // will always be 0 now
            realCurrencyType: 'EUR', // check delta dna
            adID: 'none', //
        };
    }

    // unused for resource
    public setParams(keys: Map<string, any>): void {
        keys.forEach(key => {
            if (this.curResourceData.hasOwnProperty(key)) {
                const c: any = this.curResourceData;
                c[key] = keys.get(key);
            }
        });
    }
}
